import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const addCityProfileVisiteur = async (token: string, profileData: object) => {
  try {
    const response = await Axios.put(
      `${SERVER_BASE_URL}api/profileVisiteur/add-city`,
      profileData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
